<template>
    <form @submit.prevent="sendForm">
        <button type="submit" class="k-btn" :class="[isWatching ? 'k-btn--secondary-outline' : 'k-btn--primary']">
            {{ isWatching ? 'Zrušit sledování' : `Sledovat ${targetTitle}` }}
        </button>
    </form>
</template>

<script>
    export default {
        props: {
            url: {
                type: String,
                required: true
            },
            initialValue: {
                type: Boolean,
                required: true
            },
            targetTitle: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                isWatching: this.initialValue,
                isSubmitted: false
            }
        },

        methods: {
            async sendForm() {
                if (this.isSubmitted === false) {
                    this.isSubmitted = true;

                    try {
                        let result = await axios({
                            method: 'POST',
                            url: this.url
                        });
                        if (result.status === 200 && result.data) {
                            if (result.data.success === true) {
                                this.isWatching = result.data.isWatching;
                            }
                            if (result.data.message.length) {
                                flash(result.data.message, result.data.success ? 'success' : 'danger');
                            }
                        }
                        else {
                            flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        }
                    }
                    catch(e) {
                        flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        console.log(e);
                    }
                    this.isSubmitted = false;
                }
            }
        },
    }
</script>
